import { render, staticRenderFns } from "./PurchaseAgreementModal.vue?vue&type=template&id=48b15756&scoped=true"
import script from "./PurchaseAgreementModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseAgreementModal.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseAgreementModal.vue?vue&type=style&index=0&id=48b15756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b15756",
  null
  
)

export default component.exports